/* eslint-disable no-labels */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Row, Col, Glyphicon, DropdownButton, MenuItem } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

import './dash.css'
import { useT } from '@transifex/react'
import UserItem from './User/components/UserItem'

import MyLoader from '../common/components/MyLoader'
import NewUserModal from './Modals/NewUserModal'
import useSWR from '../hooks/useSWR'
import PendingAccessRequestUserItem from './User/components/PendingAccessRequestUserItem'
import { fetchData } from '../common/redux/collectionActions'

const AllUsers = () => {
  const t = useT()
  const { data: accessRequests, mutate: mutateAccessRequests } = useSWR('/subject/admin/locks/accessrequests')
  const [predefinedSubject, setPredefinedSubject] = useState({})
  const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false)
  const [filter, setFilter] = useState({ text: '', selectedLocks: [], selectedCompanies: [] })

  const {
    admin,
    locks,
    customers,
    rental_companies: rentalCompanies,
    companies: { companies = [] },
  } = useSelector((state) => state.collectionData)

  const { state } = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)

    if (state && state.lockId) setFilter({ ...filter, selectedLocks: [state.lockId] })
  }, [state])

  useEffect(() => {
    if (rentalCompanies.length === 0) dispatch(fetchData(['rental_companies']))
  }, [rentalCompanies])

  const onToggleUserModal = () => {
    setPredefinedSubject({})
    setIsNewUserModalOpen(!isNewUserModalOpen)
  }

  const onChangeFilter = (field, value) => setFilter({ ...filter, [field]: value })

  const checkVisible = (c, contactPersonLocks) => {
    const name = `${c.name || ''} ${c.surname || ''} ${c.email || ''} ${c.phone}`.toLowerCase()

    const lowerCaseText = filter.text.toLowerCase()

    return name.includes(lowerCaseText) || (contactPersonLocks && contactPersonLocks.length > 0 && lowerCaseText.includes('kontakt'))
  }

  const toggleSelect = (type, id) => {
    const newArray = filter[type].filter((i) => i !== id)

    if (newArray.length === filter[type].length) newArray.push(id)

    setFilter({ ...filter, [type]: newArray })
  }

  if (!admin) return <div>Laddar...</div>

  const registeredUsers = customers.filter((c) => !!c.surname).sort((a, b) => (a.name > b.name ? 1 : -1))

  const invitedUsers = customers.filter((customer) => !customer.email && customer.phone)

  const filteredLocks = locks.filter((l) => !l.isCarrierDoor).sort((a, b) => (a.custom_name > b.custom_name ? 1 : -1))
  const selectedLocks = locks.filter((l) => filter.selectedLocks.includes(l._id))

  const selectedLockUsers = selectedLocks.reduce((acc, l) => acc.concat(l.users.map((u) => u.customer)), [])

  const customerFilter = (acc, c) => {
    let customerCompany

    outer: for (const lock of locks) {
      if (lock.isCarrierDoor) continue

      for (const user of lock.users) {
        if (user.company && user.customer === c._id) {
          customerCompany = user.company
          break outer
        }
      }
    }
    const foundCompany = companies.find((com) => com._id === customerCompany) || {}

    if (filter.selectedCompanies.length === 0 && filter.selectedLocks.length === 0) return acc.concat({ ...c, companyName: foundCompany.name })

    let votes = 0

    for (const user of selectedLockUsers) {
      if (user === c._id) {
        if (filter.selectedCompanies.length === 0) return acc.concat({ ...c, companyName: foundCompany.name })

        votes += 1
        break
      }
    }

    for (const company of filter.selectedCompanies) {
      if (company === customerCompany) {
        if (filter.selectedLocks.length === 0) return acc.concat({ ...c, companyName: foundCompany.name })

        votes += 1
        break
      }
    }

    if (votes === 2) return acc.concat({ ...c, companyName: foundCompany.name })

    return acc
  }

  const userModalCallback = (customer) => {
    let alternative_phone = ''
    let selectedCompany

    const selectedUserLocks = locks.reduce((acc, l) => {
      if (l.isCarrierDoor) return acc

      const foundUser = l.users.find((u) => u.customer === customer._id)

      if (foundUser) {
        if (!alternative_phone && foundUser.alternative_phone) alternative_phone = foundUser.alternative_phone
        if (!selectedCompany && foundUser.company) selectedCompany = foundUser.company

        return acc.concat({
          ...l,
          permissions: {
            storageModifyInventory: foundUser.storageModifyInventory,
            storageCreateOrder: foundUser.storageCreateOrder,
            rental: foundUser.rental,
            carrierDoorAccess: foundUser.carrierDoorAccess,
            remoteAccess: foundUser.remoteAccess,
            remoteCarrierDoorAccess: foundUser.remoteCarrierDoorAccess,
            contactPerson: foundUser.type === 'contactPerson',
          },
        })
      }

      return acc
    }, [])

    const company = selectedCompany && companies.find((c) => c._id === selectedCompany)

    setIsNewUserModalOpen(true)
    setPredefinedSubject({ customer: { ...customer, company: company || { _id: '', name: '' }, locks: selectedUserLocks, alternative_phone } })
  }

  return (
    <div>
      <MyLoader />
      <br />
      {admin.type === 'admin' && (
        <div>
          <Grid className="component-width">
            <Row style={{ paddingBottom: 30 }}>
              <Col xs={12} md={3} lg={3}>
                <div style={{ textAlign: 'center', borderRadius: 20 }} className="AddUser" onClick={onToggleUserModal}>
                  {t('+ Add New User')}
                </div>
                {isNewUserModalOpen ? <NewUserModal locks={locks} predefinedSubject={predefinedSubject} rentalCompanies={rentalCompanies} modalIsOpen={true} closeModal={onToggleUserModal} /> : null}
              </Col>
            </Row>
            <Row style={{ paddingBottom: 30 }}>
              <Col xs={12} md={4}>
                <div style={{ background: '#fff', padding: 10, borderRadius: 10 }}>
                  <input style={{ border: 'none', borderBottom: '2px solid lightgrey', width: '100%', textAlign: 'center' }} onInput={(e) => onChangeFilter('text', e.target.value)} type="text" placeholder={`🔍 ${t('Search by name or mobile number')}`} />
                </div>
              </Col>
              <Col xs={12} md={1}>
                <DropdownButton className="delivery-filter-container" title={filter.selectedLocks.length > 0 ? `Valda: ${filter.selectedLocks.length} ` : t('Project ')} id="bg-nested-dropdown">
                  <MenuItem style={{ backgroundColor: 'rgb(230, 230, 230)' }} className="dropdown-menu-item" onSelect={() => setFilter({ ...filter, selectedLocks: [] })}>
                    <div>{t('Reset filter')}</div>
                  </MenuItem>
                  <div style={{ maxHeight: '410px', overflowY: 'scroll' }}>
                    {filteredLocks.map((lock) => (
                      <MenuItem key={lock._id} onSelect={() => toggleSelect('selectedLocks', lock._id)} className="dropdown-menu-item" eventKey={lock._id}>
                        <Glyphicon glyph={`glyphicon glyphicon-${filter.selectedLocks.includes(lock._id) ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                        <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{lock.custom_name}</div>
                      </MenuItem>
                    ))}
                  </div>
                </DropdownButton>
              </Col>
              <Col xs={12} md={1}>
                <DropdownButton className="delivery-filter-container" title={filter.selectedCompanies.length > 0 ? `Valda: ${filter.selectedCompanies.length} ` : t('Company ')} id="bg-nested-dropdown">
                  <MenuItem style={{ backgroundColor: 'rgb(230, 230, 230)' }} className="dropdown-menu-item" onSelect={() => setFilter({ ...filter, selectedCompanies: [] })}>
                    <div>{t('Reset filter')}</div>
                  </MenuItem>
                  <div style={{ maxHeight: '410px', overflowY: 'scroll' }}>
                    {[...companies]
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((company) => (
                        <MenuItem key={company._id} onSelect={() => toggleSelect('selectedCompanies', company._id)} className="dropdown-menu-item" eventKey={company._id}>
                          <Glyphicon glyph={`glyphicon glyphicon-${filter.selectedCompanies.includes(company._id) ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                          <div style={{ marginLeft: '5px', textAlign: 'left', color: 'black' }}>{company.name}</div>
                        </MenuItem>
                      ))}
                  </div>
                </DropdownButton>
              </Col>
            </Row>
            {accessRequests && accessRequests.length > 0 && (
              <>
                <Row>
                  <Col md={3}>
                    <h3 className="sub-title">{t('Requests')}</h3>
                  </Col>
                </Row>
                {accessRequests.map((accessRequest) => (
                  <PendingAccessRequestUserItem
                    key={accessRequest.customer._id}
                    titleStyle={{ fontSize: 16 }}
                    accessRequest={accessRequest}
                    companies={companies}
                    finishRequest={(customer) => {
                      const idx = accessRequests.findIndex((d) => d.customer._id === customer._id)

                      mutateAccessRequests([...accessRequests.slice(0, idx), ...accessRequests.slice(idx + 1)], false)

                      dispatch({
                        type: 'SUBMIT_LOCKSANDUSERS_SUCCESS',
                        payload: { customers: [customer], locks: [] },
                      })
                      dispatch(fetchData(['locks']))
                    }}
                  />
                ))}
              </>
            )}
            <Row>
              <Col md={3}>
                <h3 className="sub-title">{t('Registered')}</h3>
              </Col>
            </Row>
          </Grid>
          <Grid className="component-width">
            {registeredUsers.reduce(customerFilter, []).map((customer) => {
              const contactPersonLocks = locks.reduce((acc, l) => {
                if (!l.isCarrierDoor && (l.owner === customer._id || l.users.find((u) => u.customer === customer._id && (u.type === 'contactPerson' || u.level === 2)))) return acc.concat(l.custom_name)

                return acc
              }, [])

              const isVisible = checkVisible(customer, contactPersonLocks)
              return (
                <div key={customer._id} style={{ display: isVisible ? 'block' : 'none' }}>
                  <UserItem newUserModalWithSubject={userModalCallback} contactPersonLocks={contactPersonLocks} customers={customers} titleStyle={{ fontSize: 16 }} customer={customer} />
                </div>
              )
            })}
          </Grid>
          <br />
          <Grid className="component-width">
            <Row>
              <Col md={3}>
                <h3 className="sub-title">{t('Invited')}</h3>
              </Col>
            </Row>
          </Grid>
          <Grid className="component-width">
            {invitedUsers.reduce(customerFilter, []).map((customer) => {
              const isVisible = checkVisible(customer)

              return (
                <div key={customer.phone} style={{ display: isVisible ? 'block' : 'none' }}>
                  <UserItem newUserModalWithSubject={userModalCallback} customers={customers} titleStyle={{ fontSize: 16 }} customer={customer} key={customer.phone} />
                </div>
              )
            })}
          </Grid>
        </div>
      )}
    </div>
  )
}

export default AllUsers
